(function () {
  var prose = document.querySelector('.hb-prose');
  var toc = document.querySelector('[data-toc]');

  /* "In this guide" sidebar. The design hand-writes its links because it also
     hand-writes the article; a real article's headings come from the rich-text
     editor and carry no ids, so build both here from what actually rendered. */
  if (prose && toc) {
    var heads = prose.querySelectorAll('h2');
    var made = 0;

    heads.forEach(function (h, i) {
      var text = (h.textContent || '').trim();
      if (!text) return;

      if (!h.id) {
        var slug = text.toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .slice(0, 60);
        h.id = slug ? (document.getElementById(slug) ? slug + '-' + i : slug) : 'section-' + i;
      }

      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      toc.appendChild(a);
      made++;
    });

    /* An article with no h2s would leave an empty, unexplained box. */
    if (!made) {
      var box = toc.closest('[data-toc-box]');
      if (box) box.hidden = true;
    }
  }

  /* Editor tables are fixed-width and shove the layout sideways on a phone.
     Wrap each one so it scrolls inside its own column instead. */
  if (prose) {
    prose.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains('hb-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'hb-tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }
})();
